import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import Problem from "@/components/sections/Problem";
import Solution from "@/components/sections/Solution";
import Pillars from "@/components/sections/Pillars";
import Phases from "@/components/sections/Phases";
import ForWhom from "@/components/sections/ForWhom";
import Testimonials from "@/components/sections/Testimonials";
import CTASection from "@/components/sections/CTASection";
import FAQSection from "@/components/sections/FAQSection";

export default function Home() {
    useEffect(() => {
        document.title = "90 Day Alpha | Men’s Dating & Confidence Coaching";
    }, []);
    return (
        <div data-testid="home-page">
            <Hero />
            <Problem />
            <Solution />
            <Pillars />
            <Phases />
            <ForWhom />
            <Testimonials />
            <CTASection />
            <FAQSection limit={5} />
        </div>
    );
}
